// extracted by mini-css-extract-plugin
var _1 = "LeftSideNav-module__avatar--z5HQJ";
var _2 = "LeftSideNav-module__copyright--aWjsG CoreGeneral__robotoSlab--X8lgW";
var _3 = "LeftSideNav-module__horizontalNavButton--T46WX";
var _4 = "LeftSideNav-module__horizontalNavButtonIcon--XS0Zb";
var _5 = "LeftSideNav-module__horizontalNavButtonLabel--WeLcQ";
var _6 = "LeftSideNav-module__horizontalNavButtonOuter--fobMM";
var _7 = "LeftSideNav-module__horizontalNavButtonUnderline--oRB76";
var _8 = "LeftSideNav-module__leftSideNav--M1t2E";
var _9 = "LeftSideNav-module__logo--JUq1n";
var _a = "LeftSideNav-module__moreDropdownContainer--FyWgK";
var _b = "LeftSideNav-module__moreDropdownContainerBackdrop--xO2rv";
var _c = "LeftSideNav-module__navButton--wvfNi";
var _d = "LeftSideNav-module__navButtonContent--Ymx4v";
var _e = "LeftSideNav-module__navButtonContentLink--Jkbfc";
var _f = "LeftSideNav-module__navButtonContentWrapper--TmxH3";
var _10 = "LeftSideNav-module__navButtonIcon--DxnY0";
var _11 = "LeftSideNav-module__navButtonLabel--Rwxxq";
var _12 = "LeftSideNav-module__navButtonSelected--O7Z1f";
export { _1 as "avatar", _2 as "copyright", _3 as "horizontalNavButton", _4 as "horizontalNavButtonIcon", _5 as "horizontalNavButtonLabel", _6 as "horizontalNavButtonOuter", _7 as "horizontalNavButtonUnderline", _8 as "leftSideNav", _9 as "logo", _a as "moreDropdownContainer", _b as "moreDropdownContainerBackdrop", _c as "navButton", _d as "navButtonContent", _e as "navButtonContentLink", _f as "navButtonContentWrapper", _10 as "navButtonIcon", _11 as "navButtonLabel", _12 as "navButtonSelected" }
